import { useFormik } from "formik";
import TradeSchema from "./tradeSchema";

export const useTradeFormConfig = () => {
  const tradeForm = useFormik({
    initialValues: {
      algoKey: "SMAPC",
      statergyType: "R",
      availableBudget: 0,
      tradeBudget: 0,
      budgetPerTrade: 0,
      tradeType: "B",
      runProcessType: "Instant",
      scheduleHour: 0,
      scheduleMin: 0,
      stopProfit: 3,
      stopLoss: 3,
      scanInterval: 30000,
    },
    validationSchema: TradeSchema,
    onSubmit: async () => {},
  });

  const populateValues = (budgetConfig) => {
    if (!budgetConfig) return;
    tradeForm.setFieldValue("availableBudget", budgetConfig.tradeBalance);
    tradeForm.setFieldValue("tradeBudget", budgetConfig.tradeBalance ?? budgetConfig.tradeBudget);
    tradeForm.setFieldValue("budgetPerTrade", budgetConfig.budgetPerTrade);
  };

  return { tradeForm, populateValues };
};
